import Vue from 'vue'
import './plugins/vuetify'

import router from './router';

import axios from 'axios';
import VueAxios from 'vue-axios';
import VueI18n from 'vue-i18n'
import Languages from './languages/languages.js'
import ModalBus from './plugins/modalBus.js'
import storePlugin from './plugins/store.js'
import Settings from './plugins/settings.js'
import API from './plugins/api.js'
import Helpers from './plugins/helpers.js'
import App from './App.vue'

import currency from 'v-currency-field'

import '@fortawesome/fontawesome-free/css/all.css'


Vue.use(VueAxios, axios);

Vue.use(VueI18n)
const i18n = new VueI18n({
	locale: 'en',
	messages: Languages.translations,
})

import Storage from 'vue-ls';

Vue.use(Storage, {
	namespace: 'malikapp__', // key prefix
	name: 'ls', // name variable Vue.[ls] or this.[$ls],
	storage: 'local', // storage name session, local, memory
});


import CrossTabBus from './plugins/crossTabBus.js'

Vue.use(CrossTabBus);

Vue.use(ModalBus)

Vue.use(storePlugin)

Vue.use(Settings)

Vue.use(API)

Vue.use(Helpers)

Vue.config.productionTip = false

Vue.use(currency)

new Vue({
	i18n,
	router: router,
	render: h => h(App),
}).$mount('#app')
